function slider() {
  const sliders = document.querySelectorAll('.slider-video-wrapper .splide');
  
  sliders.forEach(slider => {
    let splideInstance;

    const wrapper = slider.closest('.slider-video-wrapper');
    const mobileSpeed = parseInt(wrapper.dataset.mobileSpeed) || 1000;
    const desktopSpeed = parseInt(wrapper.dataset.desktopSpeed) || 1000;

    function initVideoModal() {
      const mediaQuery = window.matchMedia('(max-width: 63.9375rem)');

      function handleScreenChange(e) {
        e.matches ? setupVideoModal() : removeVideoModal();
        handleDesktopBehavior();
      }

      function handleDesktopBehavior() {
        if (window.innerWidth >= 1024) {
          const boxVideos = slider.querySelectorAll('.box-video');
          boxVideos.forEach(boxVideo => {
            boxVideo.addEventListener('click', handleBoxVideoClick);
          });
        }
      }

      function handleBoxVideoClick(event) {
        const boxVideoItem = event.currentTarget;
        const video = boxVideoItem.querySelector('.wp-block-video video');
        boxVideoItem.classList.toggle('is-playing');
        boxVideoItem.classList.contains('is-playing') ? video.play() : video.pause();
        handleOtherVideos(boxVideoItem);
      }

      function handleOtherVideos(clickedVideo) {
        const splideSlides = slider.querySelectorAll('.splide__slide');
        splideSlides.forEach(slide => {
          const boxVideo = slide.querySelector('.box-video');
          const video = slide.querySelector('.wp-block-video video');
          if (boxVideo && boxVideo !== clickedVideo) {
            boxVideo.classList.remove('is-playing');
            video.pause();
            video.currentTime = 0;
          }
        });
      }

      function setupVideoModal() {
        const boxVideos = document.querySelectorAll('.box-video');
        const body = document.querySelector('body');
        const modalBg = document.createElement('div');
        modalBg.className = 'modal-bg';

        boxVideos.forEach(boxVideo => {
          const playButton = boxVideo.querySelector('.box-video__play');
          const closeButton = boxVideo.querySelector('.box-video__close');
          const video = boxVideo.querySelector('.wp-block-video');
          const content = boxVideo.querySelector('.box-video__content');
          let modal = document.querySelector('.video-modal') || createModal();

          if (playButton) {
            playButton.addEventListener('click', () => openModal(modal, video, content, closeButton, boxVideo));
          }

          if (closeButton) {
            closeButton.addEventListener('click', () => closeModal(modal, boxVideo));
          }
        });

        function createModal() {
          const modal = document.createElement('div');
          modal.className = 'video-modal box-video';
          document.body.appendChild(modal);
          body.appendChild(modalBg);
          return modal;
        }

        function openModal(modal, video, content, closeButton, boxVideo) {
          const modalContentVideo = video.cloneNode(true);
          const videoFullscreen = modalContentVideo.querySelector('video');
          const modalContent = content.cloneNode(true);
          const modalCloseButton = closeButton.cloneNode(true);

          modal.innerHTML = '';
          modal.appendChild(modalCloseButton);
          modal.appendChild(modalContentVideo);
          modal.appendChild(modalContent);
          modal.style.display = 'block';

          setTimeout(() => {
            modal.classList.add('is-visible');
            if (videoFullscreen) {
              videoFullscreen.play().catch(error => {
                console.log('Video playback failed:', error);
              });
            }
          }, 100);
          boxVideo.classList.add('is-playing');

          modalCloseButton.addEventListener('click', () => closeModal(modal, boxVideo));
        }

        function closeModal(modal, boxVideo) {
          modal.classList.remove('is-visible');
          setTimeout(() => modal.style.display = 'none', 1000);
          boxVideo.classList.remove('is-playing');
        }
      }

      function removeVideoModal() {
        const modal = document.querySelector('.video-modal');
        if (modal) modal.remove();
      }

      mediaQuery.addListener(handleScreenChange);
      handleScreenChange(mediaQuery);
    }

    function initSlider() {
      if (splideInstance) splideInstance.destroy();

      splideInstance = new Splide(slider, {
        type: 'slide',
        speed: window.innerWidth < 1024 ? mobileSpeed : desktopSpeed,
        perPage: 1,
        perMove: 1,
        gap: '0',
        autoHeight: true,
        lazyload: 'sequential',
        rewind: true,
        mediaQuery: 'min',
        pagination: true,
        arrows: false,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        interval: 7000,
        focusableNodes: true,
        fixedWidth: '16.75rem',
        breakpoints: {
          1024: {
            perPage: 1,
            perMove: 1,
            gap: '1.5rem',
            pagination: false,
            arrows: true,
            fixedWidth: '21.25rem',
            autoplay: false,
            rewind: false,
          }
        },
      });

      splideInstance.on('mounted', handleMounted);
      splideInstance.on('move', handleMove);
      splideInstance.mount();
    }

    function handleMounted() {
      const slides = slider.querySelectorAll('.splide__slide');
      slides[0]?.classList.add('scale-in');
    }

    function handleMove(newIndex, prevIndex, destIndex) {
      const slides = slider.querySelectorAll('.splide__slide');
      slides.forEach((slide, index) => {
        slide.classList.toggle('scale-in', index === destIndex);
        slide.classList.toggle('fade-out', index < destIndex);
      });
    }

    function sliderNavPosition() {
      const sliderTextHeight = document.querySelectorAll('.slider-video .slider-video__text');
      sliderTextHeight.forEach(textHeight => {
        const sliderNav = slider.querySelector('.splide__nav-wrapper');
        sliderNav.style.top = `${textHeight.offsetHeight / 16}rem`;
      });
    }

    initVideoModal();
    initSlider();
    sliderNavPosition();

    window.addEventListener('resize', initSlider);
    window.addEventListener('resize', sliderNavPosition);
  });
}

document.addEventListener('DOMContentLoaded', slider);
